import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-report-xml';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollReportXmlEffects {

    FunkprotokollReportXml$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_REPORT_XML),
        mergeMap((x: ac.GetFunkprotokollReportXmlAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollReportXml(x.veranstaltung_id, x.fall_id).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollReportXmlErfolgreichAction(x.veranstaltung_id, x.fall_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollReportXmlFehlerAction(error, x.veranstaltung_id, x.fall_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
